import type { ChartGranularity } from '@/shared/ui';

import {
  BookingPlatform,
  MessengerProvider,
  OrderSource,
  PaymentProvider,
  PlatformActivityKind,
  PlatformOverviewBucket,
  PlatformOverviewPeriod,
} from '@shared/api/graphql/generated';

export const platformOverviewPeriodLabels: Record<PlatformOverviewPeriod, string> = {
  [PlatformOverviewPeriod.Day]: '24 ч',
  [PlatformOverviewPeriod.Week]: '7 дней',
  [PlatformOverviewPeriod.Month]: '30 дней',
  [PlatformOverviewPeriod.Quarter]: '90 дней',
  [PlatformOverviewPeriod.Year]: 'Год',
};

export const platformOverviewPeriods = Object.values(PlatformOverviewPeriod);

export const platformActivityKindLabels: Record<PlatformActivityKind, string> = {
  [PlatformActivityKind.BookingCreated]: 'Запись',
  [PlatformActivityKind.OrderCreated]: 'Заказ создан',
  [PlatformActivityKind.OrderPaid]: 'Заказ оплачен',
  [PlatformActivityKind.PaymentCaptured]: 'Платёж',
  [PlatformActivityKind.RefundCompleted]: 'Возврат',
};

export const platformBookingSourceLabels: Record<BookingPlatform, string> = {
  [BookingPlatform.AdminPanel]: 'Админка',
  [BookingPlatform.BookingPortal]: 'Онлайн-запись',
};

export const platformPaymentProviderLabels: Record<PaymentProvider, string> = {
  [PaymentProvider.Kkmserver]: 'Касса',
  [PaymentProvider.Manual]: 'Вручную',
  [PaymentProvider.Robokassa]: 'Robokassa',
};

export const platformMessengerProviderLabels: Record<MessengerProvider, string> = {
  [MessengerProvider.Max]: 'Max',
  [MessengerProvider.Telegram]: 'Telegram',
  [MessengerProvider.Vk]: 'VK',
};

export const platformOrderSourceLabels: Record<OrderSource, string> = {
  [OrderSource.BookingCheckout]: 'Касса записи',
  [OrderSource.LegacyImported]: 'Перенос',
  [OrderSource.Shop]: 'Магазин',
  [OrderSource.WorkOrder]: 'Заказ-наряд',
};

const BUCKET_GRANULARITY: Record<PlatformOverviewBucket, ChartGranularity> = {
  [PlatformOverviewBucket.Hour]: 'Hour',
  [PlatformOverviewBucket.Day]: 'Day',
  [PlatformOverviewBucket.Week]: 'Week',
};

export const getPlatformChartGranularity = (bucket: PlatformOverviewBucket): ChartGranularity =>
  BUCKET_GRANULARITY[bucket];

export type PlatformActivityFilter = 'all' | 'bookings' | 'orders' | 'payments';

export const platformActivityFilterLabels: Record<PlatformActivityFilter, string> = {
  all: 'Всё',
  bookings: 'Записи',
  orders: 'Заказы',
  payments: 'Платежи',
};

const ACTIVITY_FILTER_KINDS: Record<PlatformActivityFilter, PlatformActivityKind[] | null> = {
  all: null,
  bookings: [PlatformActivityKind.BookingCreated],
  orders: [PlatformActivityKind.OrderCreated, PlatformActivityKind.OrderPaid],
  payments: [PlatformActivityKind.PaymentCaptured, PlatformActivityKind.RefundCompleted],
};

/** `null` — все виды событий. */
export const getPlatformActivityKinds = (filter: PlatformActivityFilter): PlatformActivityKind[] | null =>
  ACTIVITY_FILTER_KINDS[filter];
